import React, { useState, useEffect } from 'react';
import { useSprings } from 'react-spring';
import { useGesture } from 'react-with-gesture';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Card from './Card';
import * as actions from '../../../../../redux/actions/recycleRight';

const Container = styled.div`
  margin: auto;
`;

const CardsDeck = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

/**
 * This component includes all the cards in each level of the game
 * This component includes all the core functions for the animation of swiping the cards
 *
 */

const Deck = ({
  currentLevelKey,
  disabled,
  onSwipeRight,
  onSwipeLeft,
  questionIndex,
  feedback,
  recycleRightData,
  windowsWidth
}) => {
  const [xValue, setXValue] = useState(null);
  const [tensionValue, setTensionValue] = useState(null);
  const objsValue = recycleRightData[currentLevelKey];

  let objs = [...objsValue].reverse();
  objs = objs.slice(0, objs.length - questionIndex);
  const cards = Array.from(Array(objs.length).keys());

  const to = (i) => ({
    x: 0,
    y: i,
    scale: 1,
    rot: 0,
    delay: i * 100
  });
  // // eslint-disable-next-line no-unused-vars, arrow-parens
  // const from = i => ({ rot: 0, scale: 1.5, y: -1000 });

  const trans = (r) => `rotateX(0deg) rotateY(${r
    / 10}deg) rotateZ(${r}deg) scale(${1})`;

  const [gone] = useState(() => new Set());

  // // eslint-disable-next-line react-hooks/rules-of-hooks
  // const [props, set] = (questionIndex === 0 && !feedback) ? useSprings(cards.length, (i) => ({
  //   ...to(i),
  //   from: from(i)
  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  // })) : useSprings(cards.length, (i) => ({
  //   ...to(i)
  // }));

  const [props, set] = useSprings(cards.length, (i) => ({
    ...to(i)
  }));

  const bind = useGesture(
    ({
      args: [index],
      down,
      delta: [xDelta],
      direction: [xDir],
      velocity
    }) => {
      const trigger = velocity > 0.2;

      const dir = xDir < 0 ? -1 : 1;

      if (!down && trigger) gone.add(index);

      set((i) => {
        if (index !== i) return;
        const isGone = gone.has(index);

        // eslint-disable-next-line no-nested-ternary
        const x = isGone ? (200 + window.innerWidth) * dir : down ? xDelta : 0;

        const rot = xDelta / 100 + (isGone ? dir * 10 * velocity : 0);

        const scale = down ? 1.1 : 1;

        // Swipre right: tension: 200 and x: 560
        // Swipre left: tension: 200 and x: -560

        setXValue(x);
        // eslint-disable-next-line no-nested-ternary
        setTensionValue(down ? 800 : isGone ? 200 : 500);
        // eslint-disable-next-line consistent-return
        return {
          x,
          rot,
          scale,
          delay: undefined,
          // eslint-disable-next-line no-nested-ternary
          config: { friction: 50, tension: down ? 800 : isGone ? 200 : 500 }
        };
      });
    }
  );

  useEffect(() => {
    if (disabled) return;
    if (tensionValue === 200 && xValue >= window.innerWidth + 200) {
      onSwipeRight();
    }
    if (tensionValue === 200 && xValue <= -1 * window.innerWidth - 200) {
      onSwipeLeft();
    }
  }, [disabled, tensionValue, xValue]);

  return (
    <Container>
      {props.map(({
        x, y, rot, scale
      }, i) => (
        <CardsDeck>
          {
            (x && y && (
              <Card
                i={i}
                x={x}
                y={y}
                rot={rot}
                scale={scale}
                trans={trans}
                cards={cards}
                objs={objs}
                bind={bind}
                onSwipeRight={onSwipeRight}
                onSwipeLeft={onSwipeLeft}
                feedback={feedback}
                windowsWidth={windowsWidth}
              />
            )
            )
          }
        </CardsDeck>
      ))}
    </Container>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.education.recycle_right
  })
)(Deck);
